import * as React from "react";
import OverlayTrigger from "components/common/OverlayTrigger";
import { Button, ButtonToolbar } from "components/bootstrap";
import useLicenseValidityForSubject from "license/hooks/useLicenseValidityForSubject";
import { LICENSE_SUBJECTS } from "license/constants";
import usePermissions from "hooks/usePermissions";
import * as ReportPermissions from "report/ReportPermissions";
import CreateButton from "components/common/CreateButton";
const ReportsSubNav = () => {
  const {
    data: { valid: isValidLicense },
    isInitialLoading: isLoadingLicense
  } = useLicenseValidityForSubject(LICENSE_SUBJECTS.report);
  const { isPermitted } = usePermissions();
  const canCreate = isPermitted(ReportPermissions.create);
  return canCreate && /* @__PURE__ */ React.createElement(ButtonToolbar, null, isLoadingLicense || isValidLicense ? /* @__PURE__ */ React.createElement(CreateButton, { entityKey: "Report" }) : /* @__PURE__ */ React.createElement(
    OverlayTrigger,
    {
      overlay: "Creating new report definitions is disabled because there is no valid license.",
      placement: "top"
    },
    /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", className: "disabled" }, "Create report")
  ));
};
export default ReportsSubNav;
